import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Toast from '../utils/Toast';
import Header from '../header/header';
import Footer from '../statics/footer';
import {Row, Col} from 'reactstrap';
import './recuperar_senha.css';
import { recoverPassword } from '../../providers/userProvider';
import { cleanRecoverState } from '../../actions';

const RecuperarSenha = (props) => {    

    const [email, setEmail] =  useState('');
    const [hasRequested, setHasRequested] = useState(false);
    const [doubleRequestError, setDoubleRequestError] = useState(false);

    const submit = event => {
        event.preventDefault();

        if(props.recoverSuccess){
            setDoubleRequestError(true);
            setTimeout(() => setDoubleRequestError(false),1000);
            return;
        }

        props.recoverPassword(email);
        
        //setHasRequested(true);
        setTimeout(() => props.cleanRecoverState(), 1500);
    }

    return(
        <div>
            {/* <Header /> */}
            <div className='menu-senha'>
                <h4> Informe um e-mail para recuperar sua senha! </h4>
                <form onSubmit={submit} className='form-forgot-password'>
                    <div className='form-group'>
                        <Row className='justify-content-center'>
                            <Col>
                                <label>E-mail</label>
                                <input 
                                    type="email" 
                                    name="email" 
                                    className="form-control input-container" 
                                    placeholder="E-mail"  
                                    onChange={(event) => setEmail(event.target.value)}
                                    value={email}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row className='justify-content-center mt-3'>
                            <button 
                                type="submit" 
                                id="senha-button" 
                                className="btn-form mb-0"> 
                                Enviar
                            </button>
                        </Row>
                    </div>
                </form>
                {props.recoverSuccess && 
                <Toast 
                    message="Um e-mail será enviado com as instruções de recuperação de senha" 
                    type="success" 
                />}
                {doubleRequestError && 
                <Toast 
                    message="Você já solicitou a recuperação de senha, um e-mail deve chegar em instantes"
                    type="error" 
                />}
                {props.recoverError && 
                <Toast 
                    message="Ocorreu um erro ao enviar seu e-mail" 
                    type="error" 
                />}
            </div>
            <Footer />
        </div>
    );
}

const mapStateToProps = (state)=>{
    return {
        recoverSuccess: state.user.resetPasswordSuccess,
        recoverError: state.user.resetPasswordError,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        recoverPassword: (email) => dispatch(recoverPassword(email)),
        cleanRecoverState: () => dispatch(cleanRecoverState()),
      };
}
export default connect(mapStateToProps,mapDispatchToProps)(RecuperarSenha);
